import Institution from '@/institutions/models/Institution';
import {CourseLike} from '.';
import {Fields} from '@vuex-orm/core';
import {Joined} from '@/orm/types/Joined';
import {RawCourse} from '@/courses/types/RawCourse';

type NoRelationshipsCourse = Omit<
  RawCourse,
  'courseLikeAssignments' | 'sections' | 'subCourse' | 'courseRoles'
>;

/**
 * Course class
 */
export class Course extends CourseLike implements NoRelationshipsCourse {
  static entity = 'Course';

  startDate!: string;
  endDate!: string;
  courseCode!: string;
  institutionId!: number;
  institution!: Joined<Institution>;
  parentCourseId!: number | null;
  subCourseId!: number | null;
  subCourse!: Joined<Course>;
  parent!: Joined<Course>;
  topLevelCourse!: Joined<Course>;
  priceId!: string | null;
  paymentDueDate!: string | null;
  effectivePaymentDueDate!: string;
  gradeDisplay!: string;
  draftsEnabled!: boolean;
  languagePreference!: string;
  inAppPaymentEnabled!: boolean;

  static fields(): Fields {
    return {
      ...super.fields(),
      startDate: this.string(null),
      endDate: this.string(null),
      courseCode: this.string(null),
      institutionId: this.number(0),
      institution: this.belongsTo(Institution, 'institutionId'),
      parentCourseId: this.number(null).nullable(),
      subCourseId: this.number(null).nullable(),
      subCourse: this.hasOne(Course, 'parentCourseId'),
      parent: this.belongsTo(Course, 'parentId'),
      priceId: this.string('').nullable(),
      paymentDueDate: this.string('').nullable(),
      effectivePaymentDueDate: this.string(''),
      gradeDisplay: this.string('percentage'),
      inAppPaymentEnabled: this.boolean(false),
      draftsEnabled: this.boolean(true),
      languagePreference: this.string('en'),
    };
  }

  /**
   * @deprecated
   */
  get title(): string {
    return this.name;
  }
}

export default Course;
